<template>
  <!-- Table Container Card -->
  <b-card id="page-orders" no-body class="mb-0 p-2">
    <b-card-header class="pl-0 pr-0">
      <b-card-title>
        <h2>{{ $t(label("title")) }}</h2>
      </b-card-title>

      <b-col v-if="canCreate" cols="12" md="8" class="d-none d-md-table">
        <b-col cols="12" class="d-flex align-items-between justify-content-end">
          <b-button id="tooltip-create" variant="primary" @click="onCreate">
            <feather-icon icon="PlusIcon" class="mr-25" />
            <span class="text-nowrap">{{ $t(label("register")) }}</span>
          </b-button>
        </b-col>
      </b-col>

      <b-col
        v-if="canCreate"
        cols="12"
        sm="12"
        md="8"
        class="d-md-none d-flex justify-content-end align-items-center pt-2"
      >
        <b-button
          id="tooltip-create"
          variant="primary"
          @click="onCreate"
          class="btn-icon"
        >
          <feather-icon icon="PlusIcon" size="18" />
        </b-button>
      </b-col>

      <b-tooltip
        placement="top"
        target="tooltip-create"
        triggers="hover"
        @click="onInfo"
      >
        <strong>
          <feather-icon icon="ExternalLinkIcon" class="mr-25 mt-0" />
          Ver tutorial
        </strong>
        <span> </span>
      </b-tooltip>
    </b-card-header>

    <!-- <Filterss
      :fields="fildsToFilters"
      @filter-applied="applyFilters"
      @filter-reset="resetFilters"
    /> -->

    <!-- Table for larger devices -->
    <b-table
      id="orders-table"
      responsive
      :head-variant="headVariant"
      :striped="striped"
      :bordered="bordered"
      :borderless="borderless"
      :outlined="outlined"
      :per-page="perPage"
      :busy="loading"
      :items="items"
      :fields="fields"
      class="d-none d-md-table shadow-sm !rounded"
    >
      <template #head()="data">
        <span class="text-black">{{
          $t(labelHeader(data.label.toLowerCase()))
        }}</span>
      </template>

      <template #cell(show_details)="row">
        <!-- As `row.showDetails` is one-way, we call the toggleDetails function on @change -->
        <b-form-checkbox
          v-model="row.detailsShowing"
          @change="row.toggleDetails"
          @input="() => toggleDetails(row.item)"
        >
          {{ row.detailsShowing ? $t("hide") : $t("show") }}
        </b-form-checkbox>
      </template>

      <template #row-details="row">
        <hr class="invoice-spacing" />
        <b-card class="border-primary">
          <b-row class="mb-2">
            <b-col sm="12" md="6" lg="6" xl="6" class="mb-1">
              <ul class="list-unstyled price-details">
                <li v-if="row.item.nameClient" class="price-detail">
                  <div class="details-title">
                    <feather-icon icon="UserIcon" class="mr-75" />
                    <span class="font-weight-bold">{{
                      row.item.nameClient
                    }}</span>
                  </div>
                </li>
                <li v-if="row.item.phoneClient" class="price-detail">
                  <div class="details-title">
                    <feather-icon icon="PhoneIcon" class="mr-75" />
                    {{ row.item.phoneClient }}
                    <!-- <strong>{{ $t(label('phone')) }}: </strong> {{ row.item.phoneClient }} -->
                  </div>
                </li>
                <li v-if="row.item.emailClient" class="price-detail">
                  <div class="details-title">
                    <feather-icon icon="MailIcon" class="mr-75" />
                    {{ row.item.emailClient }}
                  </div>
                </li>
                <li class="price-detail">
                  <div class="details-title">
                    <feather-icon icon="MapPinIcon" class="mr-75" />
                    {{ row.item.addressClient }}
                  </div>
                </li>
                <br />
                <br />

                <li style="width: 375px" class="price-detail">
                  <div style="width: 100%; padding: 4px">
                    <v-select
                      ref="statusOrder"
                      v-model="statusOrder"
                      :options="listOrderStatus"
                      input-id="statusOrder"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :placeholder="$t(label('status_order'))"
                      :reduce="(option) => option.id"
                      style="width: 100%"
                      @input="changeOrderStatus"
                    >
                      <span
                        slot="no-options"
                        click="$refs.statusOrder.open = false"
                        >{{ $t("sorryOption") }}</span
                      >
                    </v-select>
                  </div>
                  <div style="width: 180px; padding: 4px">
                    <b-button
                      style="width: 175px"
                      variant="primary"
                      @click="updatesOrderStatus(row.item)"
                    >
                      <span class="text-nowrap">{{ $t(label("update")) }}</span>
                    </b-button>
                  </div>
                </li>
              </ul>
            </b-col>

            <b-col sm="12" md="6" lg="6" xl="6" class="mb-1">
              <b-card class="no-padding">
                <ul class="list-unstyled price-details">
                  <li class="price-detail">
                    <div class="details-title">
                      {{ $t(label("cost")) }} {{ $t(label("for")) }}
                      <b-badge pill variant="light-danger">
                        <span>{{ row.item.products.length }}</span>
                      </b-badge>
                      <strong> {{ $t(label("products")) }} </strong>
                    </div>
                    <div class="detail-amt">
                      <!-- <pre>{{ row.item }}</pre> -->
                      <strong>
                        {{ roundedNumber(row.item.totalToPay) }} {{ divisa }}
                      </strong>
                    </div>
                  </li>
                  <li class="price-detail">
                    <div class="details-title">Costo en Bs</div>
                    <div class="detail-amt">
                      <strong>
                        {{
                          roundedNumber(row.item.totalToPayVESTasaConfigurada)
                        }}
                        Bs</strong
                      >
                    </div>
                  </li>
                  <li class="price-detail">
                    <div class="details-title">Gastos de envío</div>
                    <div
                      v-if="!row.item.shipping"
                      class="detail-amt discount-amt text-success"
                    >
                      Gratis
                    </div>
                    <div
                      v-else-if="row.item.shipping"
                      class="detail-amt discount-amt"
                    >
                      <strong>
                        {{ roundedNumber(row.item.shipping.amount) }}
                        {{ divisa }}
                      </strong>
                    </div>
                  </li>
                </ul>
                <hr />
                <ul class="list-unstyled price-details">
                  <li class="price-detail">
                    <div class="details-title">Costo total a pagar en Bs</div>
                    <div class="detail-amt font-weight-bolder">
                      {{ roundedNumber(row.item.totalToPayVES) }} Bs
                    </div>
                  </li>
                  <li class="price-detail">
                    <div class="details-title">Costo total a pagar</div>
                    <div class="detail-amt font-weight-bolder">
                      {{ roundedNumber(row.item.totalToPay) }} {{ divisa }}
                    </div>
                  </li>
                </ul>
              </b-card>
            </b-col>
            <b-col
              sm="12"
              md="12"
              lg="12"
              xl="12"
              class="d-flex justify-content-end"
            >
              <b-button
                id="tooltip-create"
                variant="primary"
                @click="onEdit(row.item.idOrder)"
              >
                <feather-icon icon="EyeIcon" class="mr-25" />
                <span class="text-nowrap">Ampliar detalle</span>
              </b-button>
            </b-col>
          </b-row>

          <b-button
            size="sm"
            variant="outline-secondary"
            @click="row.toggleDetails"
          >
            {{ $t("hide") }} {{ $t("details") }}
          </b-button>
        </b-card>
      </template>

      <template #cell(guid)="data">
        <b-badge pill :variant="'light-success'" @click="info(data.item.guid)">
          <feather-icon class="text-success" size="18" icon="KeyIcon" />
        </b-badge>
      </template>

      <template #cell(date)="data">
        {{ dateFormat(data.item.date) }}
      </template>

      <template #cell(payment)="data">
        <!-- {{ data.item.date }} -->
        <p v-for="(item, index) in data.item.payment" :key="index">
          {{ item.typePayment }}
        </p>
      </template>

      <!--   price -->
      <template #cell(price)="data">
        {{ "$" + data.item.price }}
      </template>

      <!-- duration -->
      <template #cell(duration)="data">
        {{ data.item.duration }} {{ data.item.nameDuration }}
      </template>

      <template #cell(nameStatus)="data">
        <div class="d-flex align-items-center">
          <b-badge
            pill
            :variant="colorStatus(data.item.nameStatus)"
            class="badge-glow"
          >
            <span>{{ data.item.nameStatus }}</span>
          </b-badge>
        </div>
      </template>

      <template #cell(actions)="data">
        <feather-icon
          class="text-primary mr-25"
          size="18"
          icon="EyeIcon"
          @click="onShow(data.item.idOrder)"
        />
      </template>

      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle ml-50"></b-spinner>
          <strong>{{ $t("loading") }}...</strong>
        </div>
      </template>
    </b-table>

    <!-- List for mobile devices -->
    <div id="list-container" class="d-block d-md-none mt-1 list-container">
      <b-list-group>
        <b-list-group-item
          v-for="item in items"
          :key="item.idOrder"
          class="flex-column align-items-start border border-primary rounded mb-1"
        >
          <div class="d-flex w-100 justify-content-between m-0 p-0">
            <p style="margin-bottom: 0 !important">
              <strong>
                {{ $t(labelHeader("name")) }} :{{ item.nameClient }}</strong
              >
            </p>

            <b-dropdown
              variant="link"
              no-caret
              class="chart-dropdown"
              toggle-class="p-0"
              right
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="18"
                  class="text-body cursor-pointer"
                />
              </template>
              <b-dropdown-item v-if="canShow" @click="onShow(item.idOrder)">
                <div class="d-flex align-items-center justify-content-between">
                  {{ $t("show") }}
                  <feather-icon
                    class="text-success mr-25"
                    size="18"
                    icon="FileTextIcon"
                  />
                </div>
              </b-dropdown-item>
              <b-dropdown-item v-if="canEdit" @click="onEdit(item.idOrder)">
                <div class="d-flex align-items-center justify-content-between">
                  {{ $t("edit") }}
                  <feather-icon
                    class="text-primary mr-25"
                    size="18"
                    icon="EditIcon"
                  />
                </div>
              </b-dropdown-item>
              <b-dropdown-item v-if="canDelete" @click="onDelete(item.idOrder)">
                <div class="d-flex align-items-center justify-content-between">
                  {{ $t("delete") }}
                  <feather-icon
                    class="text-danger"
                    size="18"
                    icon="Trash2Icon"
                  />
                </div>
              </b-dropdown-item>
            </b-dropdown>
          </div>
          {{ $t(labelHeader("date")) }} :
          {{ item.date != null ? dateFormat(item.date) : "-" }}<br />
          {{ $t(labelHeader("pay_type")) }} :
          <!-- 7 <pre>{{ item.payment }}</pre> -->
          <p v-for="(itemPay, index) in item.payment" :key="index">
            {{ itemPay.typePayment != null ? itemPay.typePayment : "-" }}
          </p>
          <br />
          <b-badge pill :variant="colorStatus(item.nameStatus)">
            <span>{{ item.nameStatus }}</span>
          </b-badge>
        </b-list-group-item>
        <b-list-group-item v-if="items.length == 0" class="text-center">
          {{ $t("notRegister") }}
        </b-list-group-item>
        <b-list-group-item v-if="loading" class="text-center">
          <b-spinner variant="success"></b-spinner>
        </b-list-group-item>
      </b-list-group>
    </div>
    <!-- pagination -->
    <div class="mx-2 d-none d-md-table">
      <b-row>
        <b-col cols="12" sm="12" md="2" lg="2" xl="2" class="mb-2">
          <b-form-group class="mb-0">
            <label class="d-inline-block text-sm-left mr-50">{{
              $t("perPage")
            }}</label>
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              @change="handlePerPageChange"
              class="w-50"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          sm="12"
          md="10"
          lg="10"
          xl="10"
          class="d-flex align-items-center justify-content-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            pills
            @change="handlePageChange"
            first-number
            last-number
          >
            <template #prev-text>
              <feather-icon size="18" icon="ChevronLeftIcon" />
            </template>
            <template #next-text>
              <feather-icon size="18" icon="ChevronRightIcon" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BPagination,
  BToast,
  BSpinner,
  BBadge,
  VBTooltip,
  BTooltip,
  BFormSelect,
  BAvatar,
  BFormGroup,
  BFormCheckbox,
  BCardBody,
  BListGroup,
  BListGroupItem,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { allOrdersByCompany, changeStatus } from "@core/api/request/orders";
import { getCatalog } from "@core/api/request/catalogs";
import { getParams, showLoading, stopLoading } from "@core/utils/utils";
import { createSignalRConnection } from "@core/api/request/signalr";
import Filterss from "../components/filters/Filterss.vue";
import { canAccess } from "@/security/permissions/permissionHelper";

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BToast,
    BSpinner,
    BBadge,
    BFormSelect,
    BFormGroup,
    BTooltip,
    BAvatar,
    vSelect,
    BFormCheckbox,
    Filterss,
    BCardBody,
    BListGroup,
    BListGroupItem,
    BDropdown,
    BDropdownItem,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data: () => ({
    connection: null,
    socketRetryTimer: null,
    ordersRefreshTimer: null,
    ordersRequestId: 0,
    isSocketDestroyed: false,
    listOrderStatus: [],
    statusOrder: null,
    loading: false,
    totalRows: null,
    currentPage: 1,
    perPage: 10,
    pageOptions: [10, 50, 100],
    headVariant: "light",
    striped: false,
    outlined: false,
    bordered: true,
    borderless: false,
    items: [],
    status: "",
    companyGuid: null,
    fields: [
      { label: "show_detail", key: "show_details", sortable: false },
      // { label: 'guid', key: "guid", sortable: true },
      // { label: 'amount', key: "amount", sortable: true },
      // { label: "date", key: "date", sortable: false },
      // { label: 'active', key: "nameStatus", sortable: false },
      // { label: 'url', key: "url", sortable: false },
      // { label: 'action', key: "actions", sortable: false  },

      { label: "id", key: "idOrder", sortable: true },
      { label: "nro_order", key: "guid", sortable: true },
      { label: "name", key: "nameClient", sortable: true },
      { label: "date", key: "date", sortable: false },
      { label: "pay_type", key: "payment", sortable: false },
      { label: "active", key: "nameStatus", sortable: false },
      { label: "action", key: "actions", sortable: false },
    ],
    fildsToFilters: [
      {
        name: "name",
        title: "name",
        placeholder: "name",
        type: "text",
        visible: true,
      },
    ],
    appliedFilters: {},
    name: null,
    filtersOn: false,
    hasNextPage: true,
  }),

  computed: {
    canCreate() {
      return canAccess("Órdenes", "creation");
    },
    canShow() {
      return canAccess("Órdenes", "reading");
    },
    canEdit() {
      return canAccess("Órdenes", "edition");
    },
    canDelete() {
      return canAccess("Órdenes", "elimination");
    },
    divisa() {
      return this.$store.state.appConfig.divisa || "USD";
    },
  },

  watch: {
    "$store.state.appConfig.activeCompanyGuid"(guid) {
      this.handleCompanyChange(guid);
    },
  },

  created() {
    this.companyGuid = this.$store.state.appConfig.activeCompanyGuid;

    this.showCatalog();
    // document.getElementById("list-container").addEventListener("scroll", this.handleScroll);

    if (this.companyGuid) {
      this.loadOrders();
      this.setupOrdersSocket();
    }
  },

  mounted() {},

  methods: {
    async handleCompanyChange(guid) {
      const companyGuid = guid;
      this.companyGuid = guid;
      this.items = [];
      this.totalRows = 0;
      this.hasNextPage = true;
      this.currentPage = 1;
      this.ordersRequestId += 1;

      if (this.ordersRefreshTimer) {
        clearTimeout(this.ordersRefreshTimer);
        this.ordersRefreshTimer = null;
      }

      if (companyGuid) this.loadOrders();
      else this.loading = false;

      await this.stopOrdersSocket();
      if (
        !this.isSocketDestroyed &&
        companyGuid &&
        companyGuid === this.companyGuid
      ) {
        this.setupOrdersSocket();
      }
    },

    setupOrdersSocket() {
      if (this.isSocketDestroyed || !this.companyGuid) return;
      this.connection = createSignalRConnection("ordersHub");
      this.registerSocketEvents();
      this.ensureSocketConnection();
    },

    async stopOrdersSocket() {
      if (this.socketRetryTimer) {
        clearTimeout(this.socketRetryTimer);
        this.socketRetryTimer = null;
      }

      const connection = this.connection;
      this.connection = null;
      if (!connection) return;

      connection.off("OrderCreated");
      try {
        await connection.stop();
      } catch (error) {
        console.log("Error al cerrar la conexión SignalR de órdenes:", error);
      }
    },

    scheduleSocketRetry(connection) {
      if (
        this.isSocketDestroyed ||
        !this.companyGuid ||
        connection !== this.connection
      )
        return;

      if (this.socketRetryTimer) clearTimeout(this.socketRetryTimer);
      this.socketRetryTimer = setTimeout(() => {
        this.socketRetryTimer = null;
        if (connection === this.connection) this.ensureSocketConnection();
      }, 3000);
    },

    async handleScroll() {
      const container = document.getElementById("list-container");
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 1
      ) {
        this.currentPage++;
        await this.loadOrdersInfinity();
      }
    },
    label(field) {
      return `pages.orders.table.${field}`;
    },

    labelHeader(field) {
      return `pages.orders.table.tableHeader.${field}`;
    },

    colorStatus(status) {
      switch (status) {
        case "Generada":
          return "secondary";
        case "Atendida":
          return "warning";
        case "Procesada":
          return "info";
        case "Terminada":
          return "success";
        case "Cancelada":
          return "danger";
        default:
          return "primary";
      }
    },

    dateFormat(date) {
      const fecha = new Date(date);
      const dia = fecha.getDate().toString().padStart(2, "0");
      const mes = (fecha.getMonth() + 1).toString().padStart(2, "0");
      // Los meses en JavaScript comienzan desde 0
      const anio = fecha.getFullYear();
      return `${dia}/${mes}/${anio}`;
    },

    toggleDetails(item) {
      this.statusOrder = item.idCatStatus;
    },

    changeOrderStatus(value) {
      this.statusOrder = value;
    },

    updatesOrderStatus(item) {
      if (!this.statusOrder) {
        this.alertToast(
          "danger",
          `Alerta`,
          "Debes seleccionar un estado para actualizar",
        );
        return;
      }
      const data = {
        idOrder: item.idOrder,
        idCatStatus: this.statusOrder,
      };
      changeStatus(data)
        .then((resp) => {
          // if (resp.status === 500) {
          // this.alertToast("danger", `Alerta`, resp.message);
          //   return;
          // }
        })
        .catch((error) => {
          console.log("error", error.message);
          this.alertToast("danger", `Alerta codigo`, error.message);
        })
        .finally(() => {
          this.loadOrders();
          this.statusOrder = null;
        });
    },

    chargeParams() {
      const arrParams = [];

      arrParams.push(`guidCompany,${this.companyGuid}`);

      arrParams.push(`page,${this.currentPage}`);

      arrParams.push(`rows,${this.perPage}`);

      if (!!this.name) arrParams.push(`name,${this.name}`);
      return getParams(arrParams);
    },

    chargeParamsWithFilters(name) {
      const arrParams = [];

      arrParams.push(`page,${this.currentPage}`);

      arrParams.push(`rows,${this.perPage}`);

      arrParams.push(`guidCompany,${this.companyGuid}`);

      arrParams.push(`active,${true}`);

      arrParams.push(`name,${name}`);
      return getParams(arrParams);
    },

    totalPay(item) {
      return item?.shipping ? item.amount + item.shipping.amount : item.amount;
    },

    ensureSocketConnection() {
      if (!this.connection) return;
      if (this.connection.state === "Connected") {
        this.joinOrdersGroup();
        return;
      }
      this.startSocket();
    },

    registerSocketEvents() {
      if (!this.connection) return;
      const connection = this.connection;
      connection.off("OrderCreated");
      connection.on("OrderCreated", () => this.handleOrderNotification());
      connection.onreconnected(() => {
        if (connection !== this.connection || this.isSocketDestroyed) return;
        console.log("SignalR reconectado para órdenes");
        this.joinOrdersGroup();
      });
      connection.onclose(() => {
        if (connection !== this.connection || this.isSocketDestroyed) return;
        console.log("Conexión SignalR cerrada; reintentando...");
        this.scheduleSocketRetry(connection);
      });
    },

    async startSocket() {
      if (!this.connection) return;
      if (
        this.connection.state === "Connected" ||
        this.connection.state === "Connecting"
      )
        return;
      const connection = this.connection;
      try {
        await connection.start();
        if (connection !== this.connection || this.isSocketDestroyed) {
          await connection.stop();
          return;
        }
        console.log("Conexión SignalR de órdenes iniciada correctamente");
        await this.joinOrdersGroup();
      } catch (error) {
        console.log("Error al conectar a SignalR:", error);
        this.scheduleSocketRetry(connection);
      }
    },

    async joinOrdersGroup() {
      if (!this.connection || !this.companyGuid) return;
      try {
        await this.connection.invoke("JoinGroup", this.companyGuid);
        console.log("Unido al grupo:", this.companyGuid);
      } catch (err) {
        console.log("Error al unirse al grupo SignalR:", err);
        this.scheduleSocketRetry(this.connection);
      }
    },

    handleOrderNotification() {
      if (this.ordersRefreshTimer) clearTimeout(this.ordersRefreshTimer);
      this.ordersRefreshTimer = setTimeout(() => {
        this.ordersRefreshTimer = null;
        this.loadOrders();
      }, 300);
    },

    async loadOrders() {
      if (!this.companyGuid) {
        this.items = [];
        this.totalRows = 0;
        this.loading = false;
        return;
      }

      const companyGuid = this.companyGuid;
      const requestId = ++this.ordersRequestId;
      const param = this.chargeParams();
      this.loading = true;
      try {
        const resp = await allOrdersByCompany(param);
        if (
          requestId !== this.ordersRequestId ||
          companyGuid !== this.companyGuid
        )
          return;

        const data = _.get(resp, "data");
        if (resp.status === 500) {
          this.alertToast("danger", `Alerta`, data?.message);
          this.items = [];
          this.totalRows = 0;
          return;
        }
        this.items = data?.items || [];
        this.totalRows = data?.totalRows || 0;
        this.hasNextPage = Boolean(data?.currentPage < data?.totalPages);
      } catch (error) {
        if (
          requestId !== this.ordersRequestId ||
          companyGuid !== this.companyGuid
        )
          return;
        console.log("error", error.message);
        this.alertToast("danger", `Alerta codigo`, error.message);
      } finally {
        if (requestId === this.ordersRequestId) this.loading = false;
      }
    },

    async loadOrdersInfinity() {
      if (!this.hasNextPage) return;
      const param = this.chargeParams();
      this.loading = true;
      allOrdersByCompany(param)
        .then((resp) => {
          const data = _.get(resp, "data");
          this.loading = false;
          if (resp.status === 500) {
            this.alertToast("danger", `Alerta`, data.message);
            this.items = [];
            this.totalRows = 0;
            return;
          }
          this.items = [...this.items, ...data?.items];
          this.totalRows = data?.totalRows || 0;
          this.hasNextPage = data?.currentPage < data?.totalPages || 0;
        })
        .catch((error) => {
          console.log("error", error.message);
          this.loading = false;
          this.alertToast("danger", `Alerta codigo`, error.message);
        });
    },

    loadOrdersWithFilters(name) {
      if (!this.hasNextPage) return;
      const param = this.chargeParamsWithFilters(name);
      this.loading = true;
      allOrdersByCompany(param)
        .then((resp) => {
          const data = _.get(resp, "data");
          this.loading = false;
          if (resp.status === 500) {
            this.alertToast("danger", `Alerta`, data.message);
            this.items = [];
            this.totalRows = 0;
            return;
          }
          this.items = data?.items || [];
          this.totalRows = data?.totalRows || 0;
          this.hasNextPage = data?.currentPage < data?.totalPages || 0;

          if (resp.data == null) {
            this.alertToast(
              "danger",
              `Error`,
              `No se encontraron coincidencias`,
            );
          }
        })
        .catch((error) => {
          console.log("error", error.message);
          this.loading = false;
          this.alertToast("danger", `Alerta codigo`, error.message);
        });
    },

    showCatalog() {
      const arrParams = getParams([
        `itemsPage,1`,
        `itemsRows,999`,
        `guidCatalog,1a9be8bf-50d7-41b6-b33c-594b0699b1a9`,
      ]);
      getCatalog(arrParams)
        .then((resp) => {
          const data = _.get(resp, "data") || [];
          this.listOrderStatus = data?.listOfItems?.items || [];
        })
        .catch((error) => {
          this.alertToast("danger", `Alerta codigo`, error.message);
        });
    },

    handlePageChange(value) {
      this.currentPage = value;
      this.hasNextPage = true;
      this.loadOrders();
    },

    handlePerPageChange() {
      this.currentPage = 1;
      this.hasNextPage = true;
      this.loadOrders();
    },

    roundedNumber(value) {
      if (value !== null) {
        return value?.toFixed(2);
      } else {
        return 0;
      }
    },

    info(guid) {
      this.$swal({
        title: "Guid",
        text: guid,
        icon: "info",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    onCreate() {
      this.$router.push({
        name: "orderCreate",
        params: {
          option: 1, // option 1 to create
        },
      });
    },

    onShow(idOrder) {
      this.$router.push({
        name: "orderEdit",
        params: {
          option: 2, // option 2 to show
          idOrder: idOrder,
        },
      });
    },

    onEdit(idOrder) {
      this.$router.push({
        name: "orderEdit",
        params: {
          option: 3, // option 3 to edit
          idOrder: idOrder,
        },
      });
    },

    onInfo() {},

    onDelete(guid) {
      // this.$swal({
      //   title: this.$t("areYouSure"),
      //   text: this.$t("willNotBeAble"),
      //   icon: "warning",
      //   showCancelButton: true,
      //   confirmButtonText: this.$t("yesDelete"),
      //   customClass: {
      //     confirmButton: "btn btn-primary",
      //     cancelButton: "btn btn-outline-danger ml-1",
      //   },
      //   buttonsStyling: false,
      // }).then((result) => {
      //   if (result.value) {
      //     showLoading();
      //     deleteService(guid)
      //       .then((resp) => {
      //         stopLoading();
      //         const status = _.get(resp, "status");
      //         if (status == 500) {
      //           this.message(
      //             this.$t("Alert"),
      //             this.$t("registerHasntDeleted"),
      //             "error",
      //           );
      //           return;
      //         }
      //         this.message(
      //           this.$t("Deleted"),
      //           this.$t("beenDeleted"),
      //           "success",
      //         );
      //         this.loadOrders();
      //       })
      //       .catch((error) => {
      //         console.log("error", error);
      //         stopLoading();
      //         this.alertToast("danger", this.$t("codeAlert"), error.message);
      //       });
      //   } else if (result.dismiss === "cancel") {
      //     this.message(
      //       this.$t("canceled"),
      //       this.$t("registerDeletedCanceled"),
      //       "error",
      //     );
      //   }
      // });
    },

    /**
     * escucha los cambios de los filtros
     */
    applyFilters(filters) {
      this.appliedFilters = filters;
      this.name = filters.name;
      this.currentPage = 1;
      this.hasNextPage = true;
      this.loadOrdersWithFilters(filters.name);
    },

    /**
     * resetear los filtros
     */
    resetFilters() {
      this.appliedFilters = {};
      this.currentPage = 1;
      this.hasNextPage = true;
      this.name = null;
      this.loadOrders();
    },

    message(title, text, icon, html) {
      this.$swal({
        title,
        text,
        html,
        icon,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    },

    alertToast(type = null, title = null, message = null) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon: "CoffeeIcon",
      });
    },
  },

  beforeDestroy() {
    this.isSocketDestroyed = true;
    this.ordersRequestId += 1;
    if (this.ordersRefreshTimer) {
      clearTimeout(this.ordersRefreshTimer);
      this.ordersRefreshTimer = null;
    }
    this.stopOrdersSocket();
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.price-details {
  .price-title {
    font-weight: $font-weight-bolder;
    margin-bottom: 0.75rem;
    margin-top: 1.5rem;
  }

  .price-detail {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.75rem;

    .detail-title {
      &.detail-total {
        font-weight: $font-weight-bolder;
      }
    }
  }
}

.no-padding {
  .card-body {
    padding: 0;
  }
}
.list-container {
  height: 60vh !important; /* Ajusta el alto según tus necesidades */
  overflow-y: auto;
}
</style>
